import React from 'react';
import EmptyState from "../../Components/EmptyState";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FindIcon from '@material-ui/icons/FindInPage';
import Fab from '@material-ui/core/Fab';
import HomeIcon from '@material-ui/icons/Home';
import { Link } from 'react-router-dom';
import withStyles from "@material-ui/core/styles/withStyles";


const useStyles = makeStyles(theme => ({
    emptyStateIcon: {
        fontSize: theme.spacing(12)
    },
    button: {
        marginTop: theme.spacing(1)
    },

    buttonIcon: {
        marginRight: theme.spacing(1)
    }
}));

const NotFoundPage = () => {
    const classes = useStyles();
    return (
        <EmptyState
            icon={<FindIcon className={classes.emptyStateIcon} color="action"/>}
            title="Content Not Found"
            description="The requested URL was not found on this server"
            button={
                <Fab className={classes.button} color="secondary" component={Link} to="/" variant="extended">
                    <HomeIcon className={classes.buttonIcon}/> Powrót do strony głównej
                </Fab>
            }
        />
    );
};

export default withStyles(useStyles, {withTheme: true})(NotFoundPage);